// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1aprS","left":"StickyBox_left__CJKeX","right":"StickyBox_right__3jb9Q"};